<template>
  <div class="input-group quicksearch">
    <vue-autosuggest
      class="form-control"
      :suggestions="[{data:autocompleteLabels}]"
      :input-props="inputProps"
      :get-suggestion-value="getSuggestionValue"
      @input="quickSearchChanged"
      @click="clicked"
      @selected="selectItem"
      v-model="search"
      ref="autosuggestInput"
      aria-describedby="quicksearch"
    >
      <template slot-scope="{suggestion}">
        <span class="my-suggestion-item">{{suggestion.item.label}}</span>
      </template>
    </vue-autosuggest>
    <div class="input-group-append">
      <button class="btn btn-quicksearch" type="button" id="quicksearch">
        <i class="fas fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import filter from "lodash/filter";
import includes from "lodash/includes";
import first from "lodash/first";
import debounce from "lodash/debounce";
import { VueAutosuggest } from "vue-autosuggest";
import { transform } from "ol/proj.js";
mixin(_, {
  chain,
  filter,
  includes,
  first,
  debounce
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    VueAutosuggest
  },
  data() {
    return {
      search: "",
      searched: false,
      autocompleteList: [],
      autocompleteLabels: [],
      inputProps: {
        id: "autosuggest__input",
        onInputChange: this.quickSearchChanged,
        placeholder: this.$t("nav.quicksearch")
      }
    };
  },
  methods: {
    clicked() {
      if (this.searched) {
        this.search = "";
        this.searched = false;
      }
    },
    selectItem(val) {
      for (let item of this.autocompleteList) {
        if (item.id == val.item.id && item.type == val.item.type) {
          item.onSelect();
          this.searched = true;
          return;
        }
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.label;
    },
    quickSearchChanged: _.debounce(function(val) {
      this.autocompleteList = [];
      this.autocompleteLabels = [];

      // Uzupełnia wyniki wyszukiwania dopiero po 3 wpisanych znakach
      // oprócz wyszukiwania działek - już po 1 znaku
      let numbers = val.replace("/", "").trim();
      if (numbers.length > 0 && !isNaN(numbers)) {
        this.$http
          .get(`/dzialki_pub/search_numer?search_numer=${val.split("/")[0]}`)
          .then(json => {
            json.data.features.forEach(dzialka => {
              let label =
                this.$t("search.parcel") +
                " " +
                dzialka.properties.numer +
                " " +
                dzialka.properties.wojewodztwo_nazwa +
                ", " +
                dzialka.properties.powiat_nazwa +
                ", " +
                dzialka.properties.gmina_nazwa;
              this.autocompleteList.push({
                id: dzialka.id,
                label: label,
                type: "parcel",
                data: dzialka.properties,
                onSelect: () => {
                  let extent = [
                    ...new transform(
                      [dzialka.properties.bbox[0], dzialka.properties.bbox[1]],
                      "EPSG:2180",
                      "EPSG:3857"
                    ),
                    ...new transform(
                      [dzialka.properties.bbox[2], dzialka.properties.bbox[3]],
                      "EPSG:2180",
                      "EPSG:3857"
                    )
                  ];

                  setTimeout(
                    () =>
                      this.$parent.$refs.map.map
                        .getView()
                        .fit(extent, { duration: 1000 }),
                    0
                  );
                }
              });
              this.autocompleteLabels.push({
                id: dzialka.id,
                label: label,
                type: "parcel"
              });
            });
          });
      }

      if (val.length >= 3) {
        let str = val.toLowerCase();

        this.$store.getters["jst/powiaty"].forEach(powiat => {
          if (
            powiat.nazwa.toLowerCase().startsWith(str) &&
            this.$parent.$refs.map.powiatFeatureByNazwa(powiat.nazwa)
          ) {
            let label =
              this.$t("search.district").toLowerCase() + " " + powiat.nazwa;
            this.autocompleteList.push({
              id: powiat.id,
              label: label,
              type: "powiat",
              onSelect: () => {
                this.$store.dispatch("selectPowiat", { powiat });
              }
            });
            this.autocompleteLabels.push({
              id: powiat.id,
              label: label,
              type: "powiat"
            });
          }
        });
        this.$store.getters["jst/gminy"].forEach(gmina => {
          if (
            gmina.nazwa.toLowerCase().startsWith(str) &&
            this.$parent.$refs.map.hasFiczeryForGminaByNazwa(gmina.nazwa)
          ) {
            this.autocompleteList.push({
              id: gmina.id,
              type: "gmina",
              label: gmina.nazwa,
              onSelect: () => {
                this.$store.dispatch("selectGmina", { gmina });
              }
            });
            this.autocompleteLabels.push({
              id: gmina.id,
              label: gmina.nazwa,
              type: "gmina"
            });
          }
        });
        this.$store.getters["search/tereny"].forEach(oferta => {
          if (
            this.$options.filters
              .showInLang(
                oferta.properties.nazwa,
                this.$parent.$refs.nav.currlang
              )
              .toLowerCase()
              .includes(val.toLowerCase())
          ) {
            let label =
              this.$t("search.offer").toLowerCase() +
              " " +
              this.$options.filters.showInLang(
                oferta.properties.nazwa,
                this.$parent.$refs.nav.currlang
              );

            this.autocompleteList.push({
              id: oferta.id,
              label: label,
              type: "oferta",
              onSelect: () => {
                this.$store.dispatch("showDetails", {
                  listType: "tereny",
                  item: oferta
                });
              }
            });
            this.autocompleteLabels.push({
              id: oferta.id,
              label: label,
              type: "oferta"
            });
          }
        });

        for (let hall of this.$store.getters["search/hale"]) {
          if (
            this.$options.filters
              .showInLang(
                hall.properties.nazwa,
                this.$parent.$refs.nav.currlang
              )
              .toLowerCase()
              .includes(val.toLowerCase())
          ) {
            let label = this.$options.filters.showInLang(
              hall.properties.nazwa,
              this.$parent.$refs.nav.currlang
            );
            this.autocompleteList.push({
              id: hall.id,
              label: label,
              type: "hall",
              onSelect: () => {
                this.$store.dispatch("showDetails", {
                  listType: "hale",
                  item: hall
                });
              }
            });
            this.autocompleteLabels.push({
              id: hall.id,
              label: label,
              type: "hall"
            });
          }
        }
        for (let office of this.$store.getters["search/biura"]) {
          if (
            this.$options.filters
              .showInLang(
                office.properties.nazwa,
                this.$parent.$refs.nav.currlang
              )
              .toLowerCase()
              .includes(val.toLowerCase())
          ) {
            let label =
              this.$t("search.office") +
              " " +
              this.$options.filters.showInLang(
                office.properties.nazwa,
                this.$parent.$refs.nav.currlang
              );
            this.autocompleteList.push({
              id: office.id,
              label: label,
              type: "office",
              onSelect: () => {
                this.$store.dispatch("showDetails", {
                  listType: "biura",
                  item: office
                });
              }
            });
            this.autocompleteLabels.push({
              id: office.id,
              label: label,
              type: "office"
            });
          }
        }
      }
    }, 500),

    sortLabels(x, y) {
      let a = x.split("/")[0];
      let b = y.split("/")[0];
      if (!isNaN(a) && !isNaN(b)) return a - b;
      else return x - y;
    }
  }
};
</script>

<style>
.input-group.quicksearch {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 998;
  padding: 0;
  width: 300px;
}

.input-group.quicksearch .form-control {
  font-size: 13px;
  border-radius: 50px !important;
  border: 2px solid #bdbdbd;
}

.input-group.quicksearch #autosuggest__input {
  color: #acafab;
  font-style: italic;
  width: 240px;
  border: none;
}

.input-group.quicksearch input::placeholder {
  color: #afabab;
  opacity: 1;
}

.input-group.quicksearch input:-ms-input-placeholder {
  color: #afabab;
}

.input-group.quicksearch input::-ms-input-placeholder {
  color: #afabab;
}

.input-group.quicksearch .form-control:focus {
  box-shadow: none;
}

.input-group.quicksearch .btn-quicksearch {
  color: #bdbdbd;
  background-color: transparent;
  border-radius: 50px !important;
  width: 50px;
  position: absolute;
  right: 0;
  z-index: 3;
  transition: all 0.3s ease-in-out;
}

.input-group.quicksearch .btn-quicksearch.focus,
.input-group.quicksearch .btn-quicksearch:focus {
  outline: 0;
  box-shadow: none;
}

.input-group.quicksearch .input-group-append {
  margin-left: 0px;
}

.autosuggest__results {
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
}
ul[role="listbox"] {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
ul[role="listbox"] > li:hover {
  background-color: #2a579a;
  color: #ffffff;
}
ul[role="listbox"] > li {
  cursor: pointer;
  transition: all 0.2s;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>